import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Typography,
  Avatar,
  useMediaQuery,
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Logout,
  AccountCircle,
  Settings,
  Dashboard as DashboardIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
export const NAVBAR_HEIGHT = 64;
// Styled components for the enhanced menu
const StyledMenu = styled(Menu)({
  "& .MuiPaper-root": {
    borderRadius: 12,
    minWidth: 200,
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
    overflow: "hidden",
    background: "linear-gradient(145deg, #FFFFFF, #F8FAFF)",
    border: "1px solid rgba(0, 0, 0, 0.05)",
  },
});
const MenuHeader = styled(Box)({
  padding: "16px 16px 12px",
  background: "linear-gradient(120deg, #00B894, #00A8FF)",
  color: "white",
  display: "flex",
  alignItems: "center",
  gap: "12px",
});
const StyledMenuItem = styled(MenuItem)({
  padding: "12px 16px",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: "#F0F9FF",
    transform: "translateX(4px)",
    "& .MuiSvgIcon-root": {
      color: "#00B894",
    },
  },
  "& .MuiSvgIcon-root": {
    fontSize: "1.2rem",
    color: "#5A6A7C",
    marginRight: "12px",
    transition: "all 0.2s",
  },
});
const LogoutMenuItem = styled(StyledMenuItem)({
  "&:hover": {
    backgroundColor: "#FFF5F5",
    "& .MuiSvgIcon-root": {
      color: "#FF6B6B",
    },
    "& .MuiTypography-root": {
      color: "#FF6B6B",
    },
  },
});
const Navbar = ({ onToggleSidebar }) => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [anchorEl, setAnchorEl] = useState(null);
  const isMobile = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();
  const username = localStorage.getItem("username") || "Admin";
  const avatarLetter = username.charAt(0).toUpperCase();
  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);
  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("username");
    navigate("/auth");
  };
  const handleProfile = () => {
    navigate("/profile");
    handleMenuClose();
  };
  return (
    <AppBar
      position="fixed"
      sx={{
        bgcolor: "#FFFFFF",
        color: "#333",
        height: NAVBAR_HEIGHT,
        boxShadow: "0 2px 4px rgba(0,0,0,0.06)",
      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", px: 2 }}>
        {/* Left: Sidebar Toggle + App Name (unchanged) */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <IconButton
            onClick={onToggleSidebar}
            edge="start"
            sx={{ mr: 1 }}
            disableRipple
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Charity CMS
          </Typography>
        </Box>
        {/* Right: Time & Avatar (time display unchanged) */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box sx={{ textAlign: "right" }}>
            <Typography variant="body2" fontWeight={500}>
              {currentTime.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {currentTime.toLocaleDateString("en-US", {
                weekday: "short",
                month: "short",
                day: "numeric",
                year: "numeric",
              })}
            </Typography>
          </Box>
          {/* Enhanced Avatar Menu */}
          <IconButton
            onClick={handleAvatarClick}
            disableRipple
            disableFocusRipple
            sx={{ p: 0 }}
          >
            <Avatar
              sx={{
                bgcolor: "#00B894",
                width: 36,
                height: 36,
                fontWeight: 600,
                boxShadow: "0 2px 8px rgba(0, 184, 148, 0.3)",
                "&:hover": {
                  transform: "scale(1.1)",
                  transition: "transform 0.2s",
                },
              }}
            >
              {avatarLetter}
            </Avatar>
          </IconButton>
          <StyledMenu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <Divider sx={{ my: 0.5 }} />
            <LogoutMenuItem onClick={handleLogout}>
              <Logout />
              <ListItemText>Logout</ListItemText>
            </LogoutMenuItem>
          </StyledMenu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
export default Navbar;